import React from "react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface SamplingBlockCardProps {
  motivo: string;
  fecha: string;
  isUnlocking: boolean;
  isReadOnly: boolean;
  onUnlock: () => void;
}

export const SamplingBlockCard: React.FC<SamplingBlockCardProps> = ({
  motivo,
  fecha,
  isUnlocking,
  isReadOnly,
  onUnlock,
}) => (
  <Card className="bg-red-50 border-l-4 border-red-400 shadow-md mb-8">
    <CardHeader className="flex flex-row items-center gap-3 pb-2">
      <span className="flex items-center justify-center h-8 w-8 text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z" />
        </svg>
      </span>
      <CardTitle className="text-xl font-bold text-red-700 m-0">
        Alojamiento bloqueado para muestreo
      </CardTitle>
    </CardHeader>
    <CardContent className="pl-12">
      <div className="flex items-center gap-4 mb-3">
        <span className="text-gray-700">
          <span className="font-semibold">Motivo:</span> {motivo}
        </span>
        <span className="text-gray-400">•</span>
        <span className="text-gray-700">
          <span className="font-semibold">Fecha de bloqueo:</span> {fecha}
        </span>
      </div>
      <p className="text-gray-600 text-sm mb-2">
        Este alojamiento no puede formar parte de una muestra hasta que se desbloquee. Si el motivo ya no aplica, puedes desbloquearlo.
      </p>
    </CardContent>
    <CardFooter className="pl-12">
      <Button
        type="button"
        onClick={onUnlock}
        disabled={isReadOnly || isUnlocking}
        className="gap-2 bg-red-500 hover:bg-red-600 text-white"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" />
        </svg>
        {isUnlocking ? "Desbloqueando..." : "Desbloquear para Muestreo"}
      </Button>
    </CardFooter>
  </Card>
);

export default SamplingBlockCard; 